// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WOTz","left":"styles_left__3LVYp","navigationLink":"styles_navigationLink__FAhDL"};